module.exports = __webpack_public_path__ + "files/c9feeca44f31ce58110748a37f7f19b1.png";